export default "__VITE_ASSET__DqkxVrEz__"